'use client';
import React, { isValidElement } from 'react';
import { factory } from '../../../../factory/factory.utils.mjs';
import { Typography } from '../../../../Foundations/Typography/Typography.mjs';
import { Flex } from '../../../../Layout/Flex/Flex.mjs';
import { omitText } from '../../../../utils/helpers.mjs';

const ShopTheRoomInformation = factory((props, ref) => {
  const { title, description, price, slashedPrice, brand, ...rest } = props;
  return /* @__PURE__ */ React.createElement(Flex, { direction: "column", gap: 15, ref, ...rest }, (brand || title || description) && /* @__PURE__ */ React.createElement(Flex, { direction: "column", gap: 5 }, brand && /* @__PURE__ */ React.createElement(
    Typography,
    {
      component: isValidElement(brand.text) ? "div" : brand.component || "p",
      ...omitText(brand),
      size: "label-medium-s",
      textColor: "var(--content-tertiary)"
    },
    brand.text
  ), title && /* @__PURE__ */ React.createElement(
    Typography,
    {
      component: title.component || "span",
      ...omitText(title),
      textColor: "var(--content-secondary)",
      size: "label-regular-l"
    },
    title.text
  ), description && /* @__PURE__ */ React.createElement(
    Typography,
    {
      component: isValidElement(description.text) ? "div" : description.component || "p",
      ...omitText(description),
      size: "paragraph-medium",
      textColor: "var(--content-tertiary)"
    },
    description.text
  )), (price || slashedPrice) && /* @__PURE__ */ React.createElement(Flex, { gap: 5, wrap: "wrap" }, price && /* @__PURE__ */ React.createElement(
    Typography,
    {
      component: isValidElement(price.text) ? "div" : price.component || "span",
      ...omitText(price),
      textColor: "var(--content-primary)",
      size: "label-medium-m"
    },
    price.text
  ), slashedPrice && /* @__PURE__ */ React.createElement(
    Typography,
    {
      component: isValidElement(slashedPrice.text) ? "div" : slashedPrice.component || "span",
      ...omitText(slashedPrice),
      textColor: "var(--content-tertiary)",
      size: "label-regular-m",
      textDecoration: "line-through"
    },
    slashedPrice.text
  )));
});

export { ShopTheRoomInformation };
